import { useState, useEffect, useCallback } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import toast from '../utils/toast';

import { Button, Input, Modal } from '../components/all';

import useGeneric from '../hooks/useGeneric';
import useInstrutor from '../hooks/useInstrutor';
import ModalMudanca from '../components/modals/modalMudanca';


export default function Login() {
  //#region Logica 
  const { usuario, resetUsuario } = useUserStore();
  const { GetInstrutor } = useInstrutor();
  const { LoginFunc, ForPass } = useGeneric();

  const [telefone, setTelefone] = useState('');
  const [senhaInput, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [seePass, setSeePass] = useState(false);
  // const [modalMan, setModalMan] = useState(false);
  const [checkRemember, setCheckRemember] = useState(true);
  const [telefoneEsqueci, setTelefoneEsqueci] = useState("");

  const [modalAberto, setModalAberto] = useState(false);
  const [modalTipo, setModalTipo] = useState(""); // ex: 'esqueci', 'manutencao', 'erroHora'

  const navigate = useNavigate(); // Use useNavigate aqui

  const showToast = (type, text1, text2) => {
    toast.show(type, `${text1}: ${text2}`);
  };

  const login = async () => {
    toast.dismiss();
    if (!telefone) {
      showToast('error', 'Erro', 'Por favor, insira o telefone.');
      return;
    }

    if (!senhaInput) {
      showToast('error', 'Erro', 'Por favor, insira a Senha.');
      return;
    }

    setLoading(true);
    setTimeout(() => {
      if (loading) {
        setLoading(false);
        showToast('error', 'Erro', 'Erro ao fazer login!');
      }
    }, 5000);

    const telefoneLimpo = telefone.replace(/\D/g, "");
    try {
      let responseUsuario = await LoginFunc(telefoneLimpo, senhaInput);
      // //console.log(responseUsuario);
      if (!responseUsuario) {
        return;
      }
      let atividade = responseUsuario.atividade;
      if (atividade === false && responseUsuario) {
        showToast('error', 'Erro', 'Você está desativado');
        return;
      }
      let usuarioAtual;
      if (responseUsuario === true) {
        usuarioAtual = usuario;
      } else {
        usuarioAtual = responseUsuario;
      }

      if (usuarioAtual.usuario_id != null) {
        const manutencao = usuarioAtual.configuracoes.manutencao;
        if (manutencao) {
          setModalTipo("manutencao");
          setModalAberto(true);
          return;
        }
        //console.log(usuarioAtual);
        if (usuarioAtual.tipo_usuario === "aluno") {
          rememberMe("login");
          navigate("/home");
          return;
        } else if (usuarioAtual.tipo_usuario === "instrutor") {
          rememberMe("login");
          await GetInstrutor(usuarioAtual.usuario_id);
          navigate("/selecionarAutoescola");
        }else {
          showToast('error', 'Erro', 'Tipo de usuário desconhecido!');
        }
      } else {
        return;
      }
    } catch (error) {
      console.error("Erro no login:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmEsqueciSenha = async () => {
    if (telefoneEsqueci.length >= 4) {
      const telefoneLimpo = telefoneEsqueci.replace(/\D/g, "");
      await ForPass(telefoneLimpo);
      setTelefoneEsqueci("");
      setModalAberto(false)
      setModalTipo("");
    } else {
      toast.error("telefone incorreto para solicitar senha!");
    }
  };

  const rememberMe = useCallback((type) => {
    setLoading(true);

    try {
      if (type === 'restore') {
        let senha = localStorage.getItem("senha");
        let telefone = localStorage.getItem("telefone");
        if (!senha || !telefone) {
          return;
        } else {
          setTelefone(telefone);
          setSenha(senha);
          setCheckRemember(true);
          return;
        }
      } else if (type === 'login') {
        if (checkRemember) {
          localStorage.setItem('senha', senhaInput);
          localStorage.setItem('telefone', telefone);
        } else {
          localStorage.removeItem("senha");
          localStorage.removeItem("telefone");
        }
      }
    } catch (error) {
      console.error('Erro ao salvar dados: ', error.message);
    } finally {
      setLoading(false);
    }
  }, [checkRemember, senhaInput, telefone]);

  const alterRemember = () => {
    setCheckRemember(!checkRemember)
  };

  useEffect(() => {
    rememberMe('restore');
  }, [])

  useEffect(() => {
    if(telefone.length > 0){
      setTelefoneEsqueci(telefone);
    }
  }, [modalAberto])

  const resetarUsuario = () => {
    resetUsuario();
    localStorage.removeItem("user-storage");
    setTelefone("");
    setSenha("");
    localStorage.removeItem("senha");
    localStorage.removeItem("telefone");
  }

  //#endregion    

  return (
    <div className="min-h-screen min-h-[100dvh] w-full bg-gradient-to-br from-background to-muted dark:from-neutral-900 dark:to-neutral-800 flex items-center justify-center p-4">

      <div className="w-full max-w-md bg-card dark:bg-neutral-800 rounded-none shadow-lg border-2 border-border dark:border-neutral-700 p-6 sm:p-8 flex flex-col gap-6">

        {/* Header */}
        <div className="flex flex-col gap-2 text-left">
          <div className='flex gap-2 items-center'>
            <img alt='imagem-logo' src='/LogoNovusCFC.png' height={32} width={32} className='rounded-none border-2 border-border' />
            <p className="font-medium text-foreground dark:text-neutral-100">Novus CFC</p>
          </div>

          <div className="mt-4">
            <h1 className='text-3xl font-bold text-foreground dark:text-neutral-100'>Entrar</h1>
            <p className='text-sm text-muted-foreground dark:text-neutral-400'>Acesse sua conta para continuar</p>
          </div>
        </div>

        {/* Form */}
        <div className="flex flex-col gap-4">
          <Input
            type="text"
            placeholder="Telefone"
            inputMode="numeric"
            value={telefone}
            onChange={(e) => setTelefone(e.target.value)}
            maxLength={14}
          />

          {/* Senha + toggle */}
          <div className="flex items-center w-full gap-2">
            <Input
              type={seePass ? 'text' : 'password'}
              placeholder="Senha"
              value={senhaInput}
              onChange={(e) => setSenha(e.target.value)}
            />
            <button
              onClick={() => setSeePass(!seePass)}
              className="h-[50px] px-4 rounded-none bg-secondary text-white hover:opacity-90 transition border-2 border-secondary flex items-center justify-center"
            >
              <span className="material-icons">
                {seePass ? 'visibility_off' : 'visibility'}
              </span>
            </button>
          </div>
          <p className='text-[10px] text-muted-foreground dark:text-neutral-400 text-start'>*Coloque o telefone com o DDD, mas sem o codigo do país</p>


          {/* Remember + reset */}
          <div className="flex items-center justify-between text-sm">
            <label className="flex items-center gap-2 cursor-pointer select-none text-foreground dark:text-neutral-100">
              <input
                checked={checkRemember}
                value={checkRemember}
                onChange={alterRemember}
                type="checkbox"
              />
              Salvar login
            </label>

            <span
              className="text-primary hover:opacity-80 cursor-pointer transition"
              onClick={resetarUsuario}
            >
              Limpar dados
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <Button onClick={login} loading={loading}>
            Entrar
            <span className="material-icons">login</span>
          </Button>

          {/* <Button type={2} loading={loading} onClick={() => navigate('/register')}>
            Criar conta
            <span className="material-icons">add</span>
          </Button> */}
        </div>

        {/* Forgot */}
        <div
          className='flex gap-2 items-center justify-center text-sm font-medium text-gray-600 hover:text-primary transition cursor-pointer'
          onClick={() => {
            setModalTipo("esqueci");
            setModalAberto(true);
          }}
        >
          <span>Esqueci a senha</span>
          <span className="material-icons text-sm">lock_reset</span>
        </div>

        {/* Footer */}
        <div className="pt-4 border-t border-border dark:border-neutral-700 text-xs text-muted-foreground dark:text-neutral-400 flex items-center justify-center gap-2">
          <p>Feito por NovusTech</p>
          <img className="w-4 h-4" src={'logoNovusTech.png'} alt="NovusTech logo" />
        </div>
      </div>

      {/* Modal */}
      <Modal isOpen={modalAberto}>
        {modalTipo === "esqueci" && (
          <div className="flex flex-col gap-4 text-center">
            <div>
              <h1 className="text-xl font-semibold text-foreground dark:text-neutral-100 mb-1">Recuperar senha</h1>
              <p className="text-sm text-muted-foreground dark:text-neutral-400">
                Enviaremos uma nova senha para seu telefone.
              </p>
            </div>

            <Input
              type="text"
              placeholder="Digite seu telefone"
              inputMode="numeric"
              value={telefoneEsqueci}
              onChange={(e) => setTelefoneEsqueci(e.target.value)}
              maxLength={14}
            />

            <div className="flex flex-col gap-2">
              <Button type={4} onClick={confirmEsqueciSenha}>
                Confirmar
                <span className="material-icons">check</span>
              </Button>
              <Button type={5} onClick={() => setModalAberto(false)}>
                Cancelar
                <span className="material-icons">clear</span>
              </Button>
            </div>

            <p className="italic text-xs text-muted-foreground dark:text-neutral-400">
              Pode demorar até 5 minutos para a senha chegar
            </p>
          </div>
        )}

        {modalTipo === "manutencao" && (
          <div className="flex flex-col gap-4 items-center text-center">
            <h2 className="text-lg font-semibold text-foreground dark:text-neutral-100">Sistema em manutenção</h2>
            <p className="text-sm text-muted-foreground dark:text-neutral-400">
              A autoescola está em manutenção no momento. Tente novamente mais tarde.
            </p>
            <Button back="#A61723" onClick={() => setModalAberto(false)}>
              Fechar
            </Button>
          </div>
        )}
      </Modal>

      <ModalMudanca />

      {/* Toast */}
      <ToastContainer
        position="top-center"
        theme='colored' 
        closeOnClick={true}
        limit={1}/>
    </div>
  );
}
